import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { useMoney } from '@/lib/hooks/useMoney'

interface AddOnPriceProps {
  /** The add-on's amount on the option's rhythm: monthly, or the year on an annual option. */
  amount: number
  interval: string
  currency: string
  /** Card installments the plan option offers; on an annual option the add-on is split the same way. */
  installments: number
  /** F-43: interest the buyer pays at this count, as on the plan's card price. */
  interestPercent?: number
  className?: string
}

/**
 * An add-on's price, read the way the plan's own price reads (F-36/F-37):
 * on an annual option split on the card, "+ 12× de R$ 450,00" up front and
 * "R$ 5.400,00 por ano" under it; otherwise "+ R$ 450,00/mês".
 */
export function AddOnPrice({ amount, interval, currency, installments, interestPercent = 0, className }: AddOnPriceProps) {
  const { t } = useTranslation('checkout')
  const formatMoney = useMoney()

  if (interval === 'YEARLY' && installments > 1) {
    return (
      <span className={cn('flex flex-col items-end text-right', className)}>
        <span className="text-sm font-semibold text-gray-900">
          {t('addOnsSection.installments', { count: installments, amount: formatMoney((amount * (1 + interestPercent / 100)) / installments, currency) })}
        </span>
        <span className="text-xs text-gray-500">{t('addOnsSection.yearTotal', { amount: formatMoney(amount, currency) })}</span>
      </span>
    )
  }
  return (
    <span className={cn('text-sm font-semibold text-gray-900', className)}>
      {t(interval === 'YEARLY' ? 'addOnsSection.perYear' : 'addOnsSection.perMonth', { amount: formatMoney(amount, currency) })}
    </span>
  )
}
